import styled from "styled-components";
import stc from "string-to-color";
import './style.scss';

const Advanced = ({ url, authorPrincipal }) => {

    // Color stylers
    const principal = authorPrincipal; //This not always auth'd users principal, ie per passed in var.
    const clean = principal.slice(2); //drop first two characters of principal
    const raw_ringcolor = clean.substring(0, 6); //use first six character of the remaining string
    const ringcolor = stc(raw_ringcolor); //create the color code based on prior const
    const raw_skincolor = clean.substring(6, 12); //define another chunk of principal for color gen
    const skincolor = stc(raw_skincolor); //generate color based on piece of principal
    const raw_eyecolor = clean.substring(12, 18);
    const eyecolor = stc(raw_eyecolor); //generate color for eyes based on piece of principal
    const raw_browcolor = clean.substring(18, 24);
    const browcolor = stc(raw_browcolor); //generate color for brows based on piece of principal
    // Svg construct
    const DeruptarRing = styled.svg`
    z-index: 9;
    width: 284px;
    height: 284px;
    position: absolute; 
    top: 0; 
    left: 0;
    circle {
        fill: none;
        stroke: ${ringcolor};
        stroke-linecap: round;
        stroke-miterlimit: 10;
        stroke-width: 11px;
    }
    `;
    const DeruptarSkin = styled.svg`
    z-index: 1;
    width: 284px;
    height: 284px;
    position: absolute; 
    top: 0; 
    left: 0;
    & .skinColor {
        fill: ${skincolor};
    }
    & .headColor {
        fill: ${skincolor};
    }
    & .rightChestShading {
        fill: #635f66; 
        mix-blend-mode: overlay;
        opacity: 0.75;        
    }
    & .leftChestShading {
        fill: #635f66; 
        mix-blend-mode: overlay;
        opacity: 0.75;        
    }
    & .headUnderShading {
        fill: #635f66; 
        mix-blend-mode: overlay;
        opacity: 0.75;        
    }
    & .headBackShading {
        fill: #635f66; 
        mix-blend-mode: overlay;
        opacity: 0.75;
    }             
    `;
    const DeruptarEyes = styled.svg`
    z-index: 4;
    width: 284px;
    height: 284px;
    position: absolute; 
    top: 0; 
    left: 0;
    & .leftEyeShading {
        fill: #00000042; 
        mix-blend-mode: overlay;
    }
    & .leftEyeWhite {
        fill: #fff;
    }
    & .leftEyeBallColor {
        fill: ${eyecolor};
    }
    & .rightEyeShading {
        fill: #00000042; 
        mix-blend-mode: overlay;
    }
    & .rightEyeWhite {
        fill: #fff;
    }
    & .rightEyeBallColor {
        fill: ${eyecolor};
    }    
    `;
    const DeruptarBrows = styled.svg`
    z-index: 5;
    width: 284px;
    height: 284px;
    position: absolute;
    top: 0;
    left: 0;
    & .leftBrow {
        fill: ${browcolor};
    }
    & .rightBrow {
        fill: ${browcolor};
    }
    `;

    return (
        <div id="advancedAvatarContainer">
            {/* Render advanced avatar elements */}
            <img id="bgNFT" src="https://raw.githubusercontent.com/cryptocracy/deruptars/main/advanced-deruptar-sample-bg.svg" alt="" />

            <DeruptarSkin xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46">
                <path d="M226.03,168.81l-15.874-2.475c-.426-2.991-1.247-8.219-2.612-14.984-1.172-5.904-7.565-36.137-18.038-51.474,0,0-16.726-25.395-47.845-33.068-13.498-1.108-46.838-.499-69.609,28.212-29.147,36.75,3.661,91.805,13.964,105.367l.783,1.002,.041-.024c.771,.931,1.58,1.831,2.39,2.731l.068,.078-16.31,48.94c17.691,18.885,42.796,30.734,70.717,30.734,26.741,0,50.952-10.823,68.499-28.324l-8.597-46.461c10.957-10.609,18.585-24.006,22.075-38.788l.348-1.466Z" />
                <path className="skinColor" d="M143.706,283.849c24.655,0,47.147-9.215,64.261-24.368l-8.518-49.182c-13.015,9.889-33.146,19.609-50.735,19.609-21.469,0-40.844-8.821-54.923-22.939l-16.821,50.182c17.386,16.521,40.855,26.697,66.735,26.697Z" />
                <path className="headColor" d="M150.52,178.472c-.896,.262-4.595,4.042-5.481,4.297,3.04-1.1,2.046,1.374,3.462,0,7.767-2.195-2.929-.451,7.962-1.269,3.553-1.9,23.915-4.418,27.577-5.077,5.068-.898,7.387-2.821,10.038-1.5-.119-.673,7.477-.791,7.962-1.269-4.89,7.133,3.686-.916,3.692-.923,.018-.017,.327-.33,.346-.346,.321-.338,.087,1.038,.692,1.038,.088,0-1.681-7.061-1.599-7.052-.422-2.927-1.192-7.8-2.427-14.01-1.758-8.974-3.653-20.782-7.151-30.768-.708-4.957-3.184-11.289-7.351-17.701-49.316-75.894-108.311-17.319-115.832-4.531-.711,1.853-1.77,3.561-3.119,5.148-.104,.122-.45,.552-.781,.962-.295,.416-.662,.927-.772,1.096-.7,1.07-1.309,2.184-1.879,3.322-.029,.089-.067,.174-.095,.264-.308,.968-.744,1.836-1.201,2.683,.526,1.486,.873,3.121,.861,4.997-.064,9.971-.899,19.817-1.408,29.759-.453,8.856,3.507,14.209,8.685,21.038,.769,1.015,1.288,2.144,1.616,3.329,2.037,.102,3.39,1.23,4.052,2.7l.102-.011c1.369-.355-3.411-.751,11.987,23.826,13.399,16.897,36.245,27.702,59.243,27.702,32.783,0,61.297-23.008,70.498-53.225-34.965-5.29-53.812,.884-69.68,5.523Z" />
                <path className="rightChestShading" d="M108.471,239.654s7.878,13.23,36.301,14.446c0,0-21.214,4.055-38.618-6.995l2.317-7.451Z" />
                <path className="leftChestShading" d="M195.195,237.346s-4.461,14.106-32.163,15.315c0,0,21.01,4.836,33.823-6.65l-1.66-8.665Z" />
                <path className="headUnderShading" d="M200.694,211.545l-1.245-1.245c-13.015,9.889-33.146,19.609-50.735,19.609-21.468,0-40.844-8.821-54.923-22.939l-6.916,20.634c11.995,3.746,26.123,6.048,41.608,6.974,32.993,1.971,62.874-8.715,72.211-23.033Z" />
                <path className="headBackShading" d="M158.481,222.654c-20.999,0-39.638-8.78-54.801-22.699-8.838-8.113-14.747-18.532-18.338-29.764-10.317-13.35-15.037-30.516-15.784-47.191-.132-3.494,.024-6.909,.455-10.249l-.23-.222s-27.431,45.529,27.425,93.226c31.369,27.275,64.652,22.896,85.871,15.356-.738-.647-1.476-1.294-2.214-1.941-7.327,2.264-14.926,3.482-22.384,3.482Z" />
                <path d="M220.625,169.335c-7.796,32.542-37.012,56.839-71.911,56.839-23.853,0-45.048-11.38-58.607-28.942-.876,.86-2.316,3.11-3.437,3.731,14.24,18.477,36.758,30.014,61.836,29.881,39.011-.208,69.721-25.108,75.802-60.888l-3.683-.62Z" />
                <path d="M130.19,64.185c-38.765,0-70.19,31.867-70.19,71.177,0,13.468,4.63,28.757,11.039,39.496,3.304,1.34,4.501,.889,6.633,1.172,0-.071,.01-.141,.014-.212-.288-.761-.404-1.593-.345-2.412-7.461-10.707-11.509-23.91-11.509-38.044,0-36.044,28.814-65.263,64.359-65.263,26.785,0,49.733,16.599,59.424,40.201,1.626-.816,2.545-1.062,4.726-1.127-10.353-26.211-34.603-44.987-64.15-44.987Z" />
                <path d="M73.188,167s8.456,19.56,19.879,33.702l-4.914,1.189s-16.824-29.253-18.152-33.482l3.188-1.41Z" />
                <path d="M205.148,166.664c1.289,.085,2.574,.193,3.852,.336-.452-3.085-1.221-7.882-2.422-13.958-.999-5.119-8.567-42.21-20.855-56.166-.833,.934-1.606,.326-2.723,.986,7.508,10.4,16.352,37.755,19.894,55.934,1.069,5.403,1.795,9.816,2.254,12.869Z" />
                <path d="M76.971,257.152l17.802-53.109-3.546-1.182-17.139,51.422c.944,.975,1.9,1.934,2.883,2.869Z" />
                <polygon points="98.875 272.857 108.303 239.299 110.326 242.256 104.155 275.603 98.875 272.857" />
                <path d="M210.984,256.689l-9.045-48.879-3.628,.88,9.434,50.984c1.102-.97,2.181-1.966,3.239-2.985Z" />
                <path d="M201.214,264.955l-4.774-29.547-2.698,4.358,4.272,27.464c1.085-.734,2.147-1.499,3.2-2.275Z" />
                <path d="M163.484,149.47s-14.238,3.981-5.362,8.952c8.876,4.971,5.362-8.952,5.362-8.952Z" />
                <path d="M168.337,148.641s13.499-.808,7.308,6.14c-6.191,6.948-7.308-6.14-7.308-6.14Z" />
            </DeruptarSkin>

            <img id="accentNFT" src="https://raw.githubusercontent.com/cryptocracy/deruptars/main/advanced-deruptar-sample-accent.svg" alt="" />
            <img id="mouthNFT" src="https://raw.githubusercontent.com/cryptocracy/deruptars/main/advanced-deruptar-sample-mouth.svg" alt="" />
            <img id="shirtNFT" src="https://raw.githubusercontent.com/cryptocracy/deruptars/main/advanced-deruptar-sample-shirt.svg" alt="" />

            <DeruptarEyes xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46">
                <ellipse className="leftEyeShading" cx="178.957" cy="130.72" rx="16.176" ry="16.854" transform="translate(-24.489 42.838) rotate(-12.784)" />
                <ellipse className="leftEyeOutline" cx="179.142" cy="130.294" rx="13.866" ry="13.975" transform="translate(-24.39 42.869) rotate(-12.784)" />
                <circle className="leftEyeWhite" cx="179.452" cy="129.667" r="11.802" />
                <path className="leftEyeBallColor" d="M171.988,128.185c-.592,2.708,.381,5.633,2.757,7.383,3.222,2.373,7.757,1.684,10.13-1.538,2.372-3.222,1.684-7.757-1.538-10.129-2.01-1.48-4.49-1.64-6.678-.866,.139,.076,.293,.1,.423,.197,1.611,1.186,1.955,3.454,.769,5.065-1.186,1.611-3.454,1.955-5.065,.769-.333-.245-.576-.558-.798-.88Zm8.195,.927c.365-1.137,1.583-1.762,2.719-1.397s1.762,1.583,1.396,2.719-1.583,1.762-2.719,1.396c-1.137-.365-1.762-1.583-1.396-2.719Z" />
                <ellipse className="rightEyeShading" cx="134.577" cy="137.77" rx="19.031" ry="19.829" transform="translate(-16.437 18.244) rotate(-7.31)" />
                <circle className="rightEyeOutline" cx="134.475" cy="137.501" r="16.078" />
                <circle className="rightEyeWhite" cx="134.024" cy="137.153" r="13.332" />
                <path className="rightEyeBallColor" d="M140.862,133.926c-1.249,1.883-3.788,2.398-5.672,1.15-1.883-1.249-2.398-3.788-1.15-5.672,.101-.153,.255-.238,.373-.373-2.621,.028-5.191,1.161-6.748,3.511-2.497,3.767-1.468,8.846,2.299,11.343,3.768,2.498,8.846,1.468,11.343-2.299,1.842-2.778,1.738-6.259,.06-8.902-.111,.428-.247,.854-.505,1.243Zm-8.255,6.348c-1.064,.829-2.598,.638-3.427-.426-.829-1.064-.638-2.598,.426-3.427s2.598-.638,3.427,.426c.829,1.064,.638,2.598-.426,3.427Z" />
            </DeruptarEyes>
            <DeruptarBrows xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46">
                <path className="leftBrow" d="M163.417,135.185s15.614-22.235,34.971-14.764c0,0-3.545-7.236-14.567-8.271,0,0,2.663-5.121,10.243-8.998,0,0-36.001-1.06-30.647,32.033Z" />
                <path className="rightBrow" d="M153.603,136.117s-23.087-17.865-40.109-6.001c0,0,3.03-8.863,12.179-11.501,0,0-3.805-4.34-12.09-6.301,0,0,36.345-6.467,40.02,23.803Z" />
            </DeruptarBrows>

            {/* <img id="eyeaccessoryNFT" src="https://raw.githubusercontent.com/cryptocracy/deruptars/main/advanced-deruptar-sample-eye-accessory.gif" alt="" /> */}
            {/* <img id="topNFT" src="https://raw.githubusercontent.com/cryptocracy/deruptars/main/advanced-deruptar-sample-top.svg" alt="" /> */}

            <DeruptarRing xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46">
                <circle id="_0" cx="142" cy="142" r="136.5" />
            </DeruptarRing>
        </div>
    )
}

export default Advanced;